export const loadLocalizeSdk = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://global.localizecdn.com/localize.js";
  document.head.appendChild(script);
};

export const initializeLocalize = (enabled: boolean) => {
  if (!enabled) return;

  let script = document.createElement("script");
  script.type = "text/javascript";
  const polyfillCode =
    '!function(a){if(!a.Localize){a.Localize={};for(var e=["translate","untranslate","phrase","initialize","translatePage","setLanguage","getLanguage","detectLanguage","getAvailableLanguages","untranslatePage","bootstrap","prefetch","on","off","hideWidget","showWidget","getSourceLanguage"],t=0;t<e.length;t++)a.Localize[e[t]]=function(){}}}(window);';
  try {
    script.appendChild(document.createTextNode(polyfillCode));
    document.body.appendChild(script);
  } catch {
    script.text = polyfillCode;
    document.body.appendChild(script);
  }

  script = document.createElement("script");
  script.type = "text/javascript";
  const initCode =
    'Localize.initialize({ key: "hGvwKhAZ39Qss", rememberLanguage: true, disableWidget: true, autoApprove: true });';
  try {
    script.appendChild(document.createTextNode(initCode));
    document.body.appendChild(script);
  } catch {
    script.text = initCode;
    document.body.appendChild(script);
  }
};
